import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

// Add all solid icons to the library
library.add(fas);

// Icon utility function to get FontAwesome icon from icon name
export const getFAIcon = (iconName) => {
  // Remove 'fa-' prefix if present and add 'fa' prefix
  const cleanName = iconName.replace(/^fa-/, '');
  return ['fas', cleanName];
};

// Check if an icon exists in the library
export const iconExists = (iconName) => {
  const cleanName = iconName.replace(/^fa-/, '');
  return fas[`fa${cleanName.charAt(0).toUpperCase() + cleanName.slice(1).replace(/-([a-z])/g, (g) => g[1].toUpperCase())}`] !== undefined;
};

export default { getFAIcon, iconExists };